import React, { useMemo, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import routes from './routes';

function RouteWithSubRoutes(route: any) {
  const { exact, path } = route;
  return (
    <Route
      exact={exact || false}
      path={path}
      render={(props) => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
}

export default function App() {
  const renderRouters = useMemo(() => routes.map((route, idx) => <RouteWithSubRoutes key={idx} {...route} />), []);

  useEffect(() => {
    window.gtag('send', 'page_view', {
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }, []);

  return (
    <Router>
      <Switch>{renderRouters}</Switch>
    </Router>
  );
}
